module.exports = __webpack_public_path__ + "img/pds_arr_equal.bd1f071d.svg";